<template>
  <section id="home" class="relative h-screen w-full overflow-hidden">
    <!-- Carousel Slides -->
    <div class="relative h-full w-full">
      <TransitionGroup name="fade">
        <div v-for="(slide, index) in slides" :key="slide.id" v-show="currentSlide === index"
          class="absolute inset-0 w-full h-full">
          <!-- Background Image -->
          <div class="absolute inset-0 bg-cover bg-center" :style="{ backgroundImage: `url(${slide.image})` }">
            <!-- Overlay Gradient -->
            <div class="absolute inset-0 bg-gradient-to-r from-richBlack/90 via-richBlack/60 to-transparent"></div>
          </div>

          <!-- Content -->
          <div class="relative h-full flex items-center">
            <div class="container mx-auto px-4 sm:px-6 lg:px-8">
              <div class="max-w-3xl">
                <h1
                  class="text-4xl sm:text-5xl lg:text-7xl font-display font-bold text-gold-gradient mb-6 animate-fade-in-up">
                  {{ slide.title }}
                </h1>
                <p class="text-lg sm:text-xl lg:text-2xl text-gray-300 mb-8 animate-fade-in-up"
                  style="animation-delay: 0.2s;">
                  {{ slide.subtitle }}
                </p>
                <a href="#products" class="btn-gold inline-block animate-fade-in-up" style="animation-delay: 0.4s;">
                  اكتشف المجموعة
                </a>
              </div>
            </div>
          </div>
        </div>
      </TransitionGroup>
    </div>

    <!-- Navigation Dots -->
    <div class="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-3 space-x-reverse z-10">
      <button v-for="(slide, index) in slides" :key="`dot-${slide.id}`" @click="goToSlide(index)" :class="[
        'w-3 h-3 rounded-full transition-all duration-300',
        currentSlide === index
          ? 'bg-gold-500 w-8'
          : 'bg-gray-500 hover:bg-gold-400'
      ]" :aria-label="`Go to slide ${index + 1}`"></button>
    </div>

    <!-- Navigation Arrows (Desktop) -->
    <button @click="prevSlide" class="hidden lg:flex absolute left-8 top-1/2 transform -translate-y-1/2 z-10 
             bg-gold-500/20 hover:bg-gold-500/40 text-gold-500 p-3 rounded-full 
             transition-smooth backdrop-blur-sm" aria-label="Previous slide">
      <ChevronLeft :size="32" />
    </button>
    <button @click="nextSlide" class="hidden lg:flex absolute right-8 top-1/2 transform -translate-y-1/2 z-10 
             bg-gold-500/20 hover:bg-gold-500/40 text-gold-500 p-3 rounded-full 
             transition-smooth backdrop-blur-sm" aria-label="Next slide">
      <ChevronRight :size="32" />
    </button>
  </section>
</template>

<script setup>
import { ChevronLeft, ChevronRight } from 'lucide-vue-next'
import { useCarousel } from '@/composables/useCarousel'

// Carousel slides data
const slides = [
  {
    id: 1,
    title: 'أناقة خالدة',
    subtitle: 'اكتشف مجموعتنا الرائعة من المجوهرات الذهبية المصنوعة يدوياً',
    image: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=1920&q=80'
  },
  {
    id: 2,
    title: 'فخامة نقية',
    subtitle: 'قطع ذهبية عيار 24 قيراط تحدد معنى الرقي',
    image: 'https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=1920&q=80'
  },
  {
    id: 3,
    title: 'إتقان مصنوع',
    subtitle: 'حيث يلتقي التقليد بالتصميم المعاصر',
    image: 'https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?w=1920&q=80'
  },
  {
    id: 4,
    title: 'استثمار في الجمال',
    subtitle: 'معادن ثمينة، ذكريات لا تقدر بثمن',
    image: 'https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=1920&q=80'
  }
]

// Use carousel composable
const { currentSlide, nextSlide, prevSlide, goToSlide } = useCarousel(slides.length)
</script>

<style scoped>
/* Fade transition for slides */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}
</style>
